/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendWorkingCapitalParameterDto } from '../../models/backend-working-capital-parameter-dto';

export interface FinancingSourcesWorkingCapitalParametersRetrieve$Params {
  /**
   * A unique integer value identifying this working capital parameter.
   */
  id: number;
}

export function financingSourcesWorkingCapitalParametersRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesWorkingCapitalParametersRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesWorkingCapitalParametersRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendWorkingCapitalParameterDto>;
    }),
  );
}

financingSourcesWorkingCapitalParametersRetrieve.PATH = '/api/financing_sources/working_capital_parameters/{id}/';
